module.exports = __webpack_public_path__ + "media/masterplan.450b3ab8.png";